import { useEffect } from 'react';
import { useMutation } from 'react-query';

import { axios } from '@/library/axios';
import { queryClient } from '@/library/react-query';
import { displayError } from '@/utils/functions/displayError';

export type UserAddBankType = {
  data: BankDetailsType;
  id: string;
};
export type BankDetailsType = {
  accountNumber: string;
  // confirmAccount:string;
  accountHolderName: string;
  ifscCode: string;
  // name:string;
  isDgFlow: boolean;
};
queryClient.invalidateQueries(['bankInfo']);

const addBank = (data: UserAddBankType): Promise<any> => {
  return axios.post(`dg/customers/${data.id}/bank-details`, data.data);
};

export const useAddBank = () => {
  const mutation = useMutation({
    mutationFn: addBank,
    onSuccess: () => {
      queryClient.invalidateQueries(['bankInfo']);
    },
  });

  useEffect(() => {
    displayError(mutation.error);
  }, [mutation.error]);

  return mutation;
};
